module.exports = __webpack_public_path__ + "static/turquia-004-f5aa4aaf8acdb9281d571b333dd5c08b.jpg";